import type { IAugmentedJQuery, IController, IScope } from "angular";
import { isDefined } from "angular";

export default class EllipsisDirectiveController implements IController {
    public static $inject = ["$scope", "$element"];

    private hasEllipsis = false;

    constructor(private $scope: IScope, private $element: IAugmentedJQuery) {}

    public $onInit() {
        this.addEllipsis();
        this.addAttributeWatch();
    }

    private addAttributeWatch() {
        this.$scope.$watch("mmEllipsis", () => {
            if (!isDefined((this.$scope as any).mmEllipsis) || !!(this.$scope as any).mmEllipsis) {
                this.addEllipsis();
            } else {
                this.removeEllipsis();
            }
        });
    }

    private addEllipsis() {
        if (this.hasEllipsis) {
            return;
        }
        this.hasEllipsis = true;

        this.$element.addClass("ellipsis");
        this.$element.on("mouseenter", () => {
            if (this.$element[0].offsetWidth < this.$element[0].scrollWidth) {
                this.$element.attr("title", this.$element.text());
            } else {
                this.$element.removeAttr("title");
            }
        });
    }

    private removeEllipsis() {
        if (!this.hasEllipsis) {
            return;
        }
        this.hasEllipsis = false;

        this.$element.removeClass("ellipsis");
        this.$element.off("mouseenter");
    }
}
